import { getWindow, getWindowLocation } from 'utilities/window.js';
import { QueryParams } from './types.js';

export const areParamsEqual = (newParams: QueryParams, oldParams: QueryParams): boolean => {
  const newKeys = Object.keys(newParams).length;
  const oldKeys = Object.keys(oldParams).length;
  const keys = Object.keys({ ...newParams, ...oldParams });
  return newKeys === oldKeys && keys.every((key) => newParams[key] === oldParams[key]);
};

const stringComparator = (a: string, b: string) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const getParamStringURL = (params: QueryParams): string => {
  const paramString = Object.keys(params)
    .filter((p: string) => p !== null && p !== undefined && p !== '')
    .sort(stringComparator)
    .reduce<Array<string>>((pairs, key) => (params[key] ? [...pairs, `${key}=${params[key]}`] : pairs), [])
    .join('&');

  const { protocol, host, pathname } = getWindow()?.location ?? {};

  return `${protocol}//${host}${pathname}${paramString ? `?${paramString}` : ''}`;
};

export function getCurrentParams(location: URL | undefined): QueryParams {
  const search = location?.search;
  if (!search) {
    return {} as QueryParams;
  }

  return search
    .slice(1)
    .split('&')
    .reduce((qp: QueryParams, pair: string) => {
      const [key, value] = pair.split('=');
      qp[key] = value;
      return qp;
    }, {});
}

/** Pull out the hashParam from the url without the leading hash '#' */
export function extractHashParam(href: string): string | undefined {
  const regEx = /#(.*)/;
  const match = regEx.exec(href);
  if (match && match[1]) {
    // Pull out the hashParam from the regex result without the leading hash '#'
    return match[1];
  }

  return undefined;
}

export function removeQueryParam(href: string = getWindowLocation().href): string {
  const regEx = /[?].*$/;
  return href.replace(regEx, '');
}
